/**
 * Csv Schema of Auditoria
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Auditoria} from '@/model/resource/Auditoria'

/* TODO: review generated schema */
export class CsvAuditoriaSchema extends Schema {
  readonly name = 'CsvAuditoria'

  readonly fieldSet: FieldSet<Auditoria> = {
    idAuditoriaPk: schema => schema.model.idAuditoriaPk,
    auditoriaMotivo: schema => schema.model.auditoriaMotivo?.$id ?? null,
    carga: schema => schema.model.carga?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    conforme: schema => Helper.bool(schema.model.conforme),
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    dataCanhoto: schema => Helper.datetime(schema.model.dataCanhoto),
  }
}
